import { FaceIdProfileList } from '@/features/face-id-profiles';

const FaceIdProfilePage = () => {
  return <FaceIdProfileList />;
};

export default FaceIdProfilePage;
